export class ExhaustiveMatchGuardError extends Error {
  constructor(public readonly value: unknown) {
    const message = `Exhaustive Match Guard failed for value: ${String(value)}`;

    super(message);
    this.message = message;
    this.name = this.constructor.name;
    Error.captureStackTrace(this, this.constructor);
  }
}

/**
 * Helper to enforce exhaustive switch statements through compile-time error.
 * @param value - The switch statement expression
 * @throws Error if called, indicating a non-exhaustive switch.
 *
 * @example
 * ```typescript
 * type Foo = 'foo' | 'bar';
 * const foo: Foo = 'foo';
 * switch (foo) {
 *   case 'foo':
 *     return 1;
 *   case 'bar':
 *     return 2;
 *   default:
 *     exhaustiveMatchGuard(foo);
 * }
 * ```
 */
export function exhaustiveMatchGuard(value: never): never {
  throw new ExhaustiveMatchGuardError(value);
}
